import React, { useState, useEffect } from 'react';
import { Combobox } from 'evergreen-ui';
import PropTypes from 'prop-types';
import { api } from '../../services/api';

const SelectGoogleGroupInput = ({ value, onSelect, disabled }) => {
  const [loading, setLoading] = useState(true);
  const [getGroups, setGroups] = useState([]);

  let unmounted = false;
  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await api.google.listGroups();
        if (!unmounted) {
          setGroups(data);
          setLoading(false);
        }
      } catch (error) {
        if (!unmounted) {
          setLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      unmounted = true;
    };
  }, []);

  return (
    <Combobox
      items={getGroups}
      itemToString={(item) => (item ? item : '')}
      selectedItem={value}
      onChange={(selected) => onSelect && onSelect(selected || '')}
      disabled={disabled}
      isLoading={loading}
      width="40%"
      openOnFocus
      data-testid="group"
    />
  );
};

SelectGoogleGroupInput.propTypes = {
  value: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

SelectGoogleGroupInput.defaultProps = {
  value: null,
};

export default SelectGoogleGroupInput;
